import { render, staticRenderFns } from "./ReviewLike.vue?vue&type=template&id=78ed88d7&"
import script from "./ReviewLike.vue?vue&type=script&lang=js&"
export * from "./ReviewLike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports